<template>
  <div class="hotel-row" :class="isSelected ? 'selected' : ''" @click="rowClicked">
    <b-row class="hotel-header">
      <div class="col-10">
        <h3>
          {{ offer.hotel.hotelName |capitalise }}
          <Category :stars="offer.hotel.category" />
          <span v-if="offer.hotel.greenStayInfo">
              <img class="ml-1 align-bottom" src="@/assets/img/green.png" width="30px" :title="$t('online.offer.greenStayInfo')"/>
          </span>
        </h3>
        <p>{{ offer.hotel.city }}</p>
      </div>
    </b-row>

    <b-row class="hotel-row-content">
      <div class="col-md-3 hotel-offer-image">
        <img v-if="offer.hotel.media" class ="img-responsive"
             :src="offer.hotel.media[0].mediaURL" :alt="offer.hotel.hotelName"
        />

        <img v-else class ="img-responsive" src="@/assets/img/loginBbaSquare.jpg"
             :alt="offer.hotel.hotelName"
        />
      </div>

      <div  class=" col-7 col-md-6 hotel-distances p-0">
        <div class="hotel-price">
          <span>
            {{ $t('online.offer.fromPrice') }}
            {{ offer.minPrice |currency }}
            <span v-if="!offer.fitsTravelPolicy" class="travel-policy-exceeded">
              <i class="fab fa-creative-commons-nc-eu" :title="$t('online.offer.travelPolicyExceeded')"></i>
            </span>
          </span>

          <span class="price-rebate" :title="$t('online.offer.bbaNegotiatedTitle')" v-if="offer.negotiated">
            {{ $t('online.offer.bbaNegotiated') }}
          </span>

          <span class="price-rebate" v-else-if="offer.rebate">
            - {{ offer.rebate |percent }}
          </span>

        </div>

        <div :class="[ offer.hotel.media ? 'breakfast' : 'breakfast-full' ]">
          <span v-if="offer.breakfastPrice && offer.breakfastPrice > 0">
            {{ $t('booking.show.prices.breakfast.excluded.inc', {
                price: $options.filters.currency(offer.breakfastPrice)
            })}}
          </span>

          <span v-else-if="offer.breakfastIncluded">
            {{ $t('booking.show.prices.breakfast.included') }}
          </span>

          <span v-else>
            {{ $t('booking.show.prices.breakfast.excluded.noValue') }}
          </span>
        </div>

        <distances :distances="distances" />
      </div>

      <div class="col-5 col-md-3 p-0 hotel-rating">
        <rate v-if="offer.hotel.ratings" :value="offer.hotel.ratings[0].averageRating" />

        <div class="hotel-btn-link-section">
          <div class="hotel-btn-link discover">
            <router-link :to="{ name: 'online_discover', params: { hotelKey: offer.hotelKey } }"
                         class="btn blue-white"
            >
              {{ $t('online.offer.hotel.btn.discover')}}
            </router-link>
          </div>

          <div class="hotel-btn-link details">
            <router-link :to="{ name: 'online_offers', params: { hotelKey: offer.hotelKey } }"
                         class="btn orange-white"
            >
              {{ $t('online.offer.hotel.btn.detail') }}
            </router-link>
          </div>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
import Rounded from '@/components/frontoffice/button/rounded'
import Base from '@/components/frontoffice/button/base'
import Category from '@/components/frontoffice/hotel/category'
import Rate from '@/components/frontoffice/hotel/rate'
import Distances from '@/components/frontoffice/hotel/distances'
import { getHotelDistances } from '@/utils/helpers'
import formatter from '@/components/global/mixins/formatterMethods'
import viewPortMixin from '@/conf/viewPort'

export default {
  name: 'RoomOfferCard',

  components: {
    Rounded,
    Base,
    Category,
    Rate,
    Distances
  },

  mixins: [formatter, viewPortMixin],

  props: {
    offer: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isSelected: this.selected
    }
  },

  methods: {
    rowClicked () {
      this.isSelected = true
      this.$emit('click', this.offer)
    }
  },

  computed: {
    distances () {
      return getHotelDistances(this.offer.hotel.distances)
    }
  },

  watch: {
    selected: function (val) {
      this.isSelected = val
    }
  }
}
</script>

<style lang="scss">
  h6 {
    .category {
      font-size: 0.5em;
      vertical-align: top;
    }
  }

  .selected {
    background-color: rgba(230, 80, 17, 0.1); // $orange with 0.1 opacity
  }
</style>
